import useSWR from 'swr';
import { getDriverStatus, fetcher } from 'utils/network/http';

const useDriverStatus = ({ profile }) => {
  const { data: driverStatus } = useSWR(
    profile ? getDriverStatus(profile.driver.id) : null,
    fetcher,
    {
      refreshInterval: 60000
    }
  );

  return {
    isDriverActive: driverStatus?.data?.status === 'active'
  };
};

export default useDriverStatus;
